import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { CreateCategoryForm } from '~/components/forms/CategoryForm';
import { CategoryBreadcrumbs } from '~/components/organisms/Breadcrumbs';
import { useNavigate } from '~/components/utils/Navigation';

export type IAppCreateCategoryPageProps = {
  appId: string;
  parentCategoryId?: string;
};

export const AppCreateCategoryPage: React.FC<IAppCreateCategoryPageProps> = (
  props,
) => {
  const { appId, parentCategoryId } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>{t('AppCreateCategoryPage.title')}</title>
      </Helmet>

      <CategoryBreadcrumbs appId={appId} categoryId={parentCategoryId} />

      <CreateCategoryForm
        appId={appId}
        parentCategoryId={parentCategoryId}
        onSuccess={(createdCategory) =>
          navigate(
            createdCategory.parentId
              ? `/apps/${appId}/categories/${createdCategory.parentId}`
              : `/apps/${appId}/categories`,
          )
        }
        cancelUrl={
          parentCategoryId
            ? `/apps/${appId}/categories/${parentCategoryId}`
            : `/apps/${appId}/categories`
        }
      />
    </>
  );
};
